export default __webpack_public_path__ + "static/media/service-software-development.011a5663.jpg";